import React from "react";
import { createRoot } from "react-dom/client"; 
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import store from "./store";
import { AxiosSetup } from "./utils/helpers/api.helpers";

AxiosSetup();

const root = createRoot(document.getElementById("root")); 

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
